import '@site/styles/sass/styles.scss';
import 'select2/dist/css/select2.min.css';
import 'basiclightbox/dist/basicLightbox.min.css';

import $ from 'jquery';
window.$ = window.jQuery = $;
import select2 from 'select2';
import * as basicLightbox from 'basiclightbox';
import './vendor/jquery-ui.min.js';
import 'jquery-validation';
import 'slick-carousel';
import './vendor/niceSelect.js';
import { addClass, removeClass, toggleClass, hasClass, siblings, setText, attn } from './plugins.js';
import './module/modal';
import './module/genericAutoComplete';
import './module/genericSearch';
import './module/nav';
import Recaptcha from './module/recaptcha';

if (!jQuery.fn.select2 && typeof select2 === 'function') {
	select2(jQuery);
}

// var funcHandleOnError = function(msg, src, lno, cno, error) {
// 	return;
// 	var q = _ad.qString(window.location.search),
// 		getVar = '';

// 	if (q && JSON) {
// 		getVar = JSON.stringify(q);
// 	}

// 	$.ajax('/handleerror', {
// 		data: {
// 			time: 			new Date(),
// 			domain: 		window.location.protocol + '//' + window.location.host,
// 			url: 			window.location.pathname,
// 			get: 			getVar,
// 			message: 		msg,
// 			source: 		src,
// 			linenumber: 	lno,
// 			columnnumber: 	cno,
// 			error: 			error,
// 			stack: 			error.stack || {},
// 			useragent: 		window.navigator.userAgent
// 		}
// 	});
// };
// window.onerror = funcHandleOnError;

const buttons = document.querySelectorAll('.lightbox a');
for (const button of buttons) {
    button.addEventListener('click', function (event) {
        event.preventDefault();
        console.log(event.target.href);
        basicLightbox.create(`<img width="1400" height="900" src="${event.target.href}">`).show();
    });
}


var _window;

function initMap() {
	_window.trigger('mapReady');
}
window.initMap = initMap;

(function(){
	_window = $(window);

	_window.on('load', function(){
		$('body').addClass('docready');
	});

	// ---
	// Nav
	// ---
	var elNavToggleText = document.querySelector('.nav-main_toggle_text');

	$('.js-nav-toggle')
		.on('click', function(){
			toggleClass(document.body, 'site_nav_open');


			if (hasClass(document.body, 'site_nav_open')) {
				setText(elNavToggleText, this.getAttribute('data-text-open'));
				addClass(this, 'nav-main_toggle_open');
			} else {
				setText(elNavToggleText, this.getAttribute('data-text-closed'));
				removeClass(this, 'nav-main_toggle_open');
			}
		});

	// Add a handler around focusing on sub nav items for accessibility //
	$('.nav-main')
		.each(function(index, elNav){
			var elLinks = elNav.querySelectorAll('a');

			$(elLinks)
				.on('focus', function(){
					$(this).parents('li').addClass('focus');
				})
				.on('blur', function(){
					$(this).parents('li').removeClass('focus');
				});
		});

	// Automatically set links with a different domain to open in a new window
	$('[href^=http]').each(function(){
		if(this.href.indexOf(window.location.hostname) < 0) {
			this.target = '_blank';
			// this.setAttribute('rel', 'external');
		}
	});

	$('.js-form-autosubmit')
		.on('change', function(){
			this.submit();
		});


	// -----------
	// Nice Select
	// -----------
	$('.js-nice-select')
		.niceSelect()
		.each(function(index, el){
			if (el.getAttribute('data-theme')) {
				addClass(el.parentNode, el.getAttribute('data-theme'));
			}
		});

    // -----------
	// Select2
	// -----------
	$('.js-select2').select2()
		.on('change', function() {
			$(this).valid();
		})
		.on('select2:opening select2:closing', function( event ) {
			var $searchfield = $(this).parent().find('.select2-search__field');
			$searchfield.prop('disabled', true);
		});

	// -----------------
	// Email Obfuscation
	// -----------------
	$('.js-email-hidden')
		.each(function(index, element){
			setText(element, element.getAttribute('data-user') + '@' + element.getAttribute('data-domain'));

			element.href = 'mailto:' + element.getAttribute('data-user') + '@' + element.getAttribute('data-domain');
		});


	// --------------
	// External Links
	// --------------
	$('[rel=external]').attr('target', '_blank');


	// --------------
	// Image Captions
	// --------------
	$('img[title]').each(function(index, elImg){
		var _image = $(elImg),
			__figure = $('<figure />'),
			__figcaption = $('<figcaption />');

		var f = elImg.style.cssFloat || elImg.style.styleFloat || false;

		if (f === 'left') {
			__figure.addClass('fig-left');
		} else if (f === 'right') {
			__figure.addClass('fig-right');
		}

		_image
			.addClass('fig-img')
			.after(__figure);

		__figcaption
			.text(_image.attr('title'));

		__figure
			.append(_image)
			.append(__figcaption);

		__figure
			.css({
				paddingBottom: __figcaption.outerHeight()
			});

		_image = null;
		__figure = null;
		__figcaption = null;
	});


	// --------------
	// Slick Carousel
	// --------------
	// $('.js-slick-carousel').slick({
	// 	dots: true,
	// 	infinite: false,
	// 	speed: 300,
	// 	slidesToShow: 4,
	// 	slidesToScroll: 4,
	// 	responsive: [{
	// 		breakpoint: 1024,
	// 		settings: {
	// 			slidesToShow: 3,
	// 			slidesToScroll: 3,
	// 			infinite: true,
	// 			dots: true
	// 		}
	// 	}, {
	// 		breakpoint: 600,
	// 		settings: {
	// 			slidesToShow: 2,
	// 			slidesToScroll: 2
	// 		}
	// 	}, {
	// 		breakpoint: 480,
	// 		settings: {
	// 			slidesToShow: 1,
	// 			slidesToScroll: 1
	// 		}
	// 	}]
	// });

	$('.js-slick-carousel').slick({
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1
	});

	$('.js-slick-quotes')
		.each(function(index, el){
			var elSlides = el.querySelectorAll('.cb-quote_quote');

			if (elSlides.length < 2) return; // Only initialise slider if more than one image //

			$(el).slick({
				dots: false,
				infinite: true,
				prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="51" height="96" viewBox="0 0 51 96" xml:space="preserve"><use xlink:href="#svgSlickPrev" class="svg-prev" /></svg></button>',
				nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="51" height="96" viewBox="0 0 51 96" xml:space="preserve"><use xlink:href="#svgSlickNext" class="svg-next" /></svg></button>',
				speed: 300,
				slidesToShow: 1,
				slidesToScroll: 1
			});
		});


	// ---------------
	// Form Validation
	// ---------------b
	// http://jqueryvalidation.org/validate
	jQuery.validator.addMethod('phoneUK', function(phone_number, element) { // add Class phoneUK to phone fields
		return this.optional(element) || phone_number.length > 9 &&
			phone_number.match(/^(((\+44)? ?(\(0\))? ?)|(0))( ?[0-9]{3,4}){3}$/);
	}, 'Please specify a valid phone number');

	jQuery.validator.addMethod('mobileUK', function(phone_number, element) { // add Class mobileUK to phone fields
		return this.optional(element) || phone_number.length > 9 &&
			phone_number.match(/^((\+44\s?|0)7([1345789]\d{2}|624)\s?\d{3}\s?\d{3})$/);
	}, 'Please specify a valid mobile number');

	jQuery.validator.addMethod('postcodeUK', function(value, element) { // add Class postcodeUK to postcode fields
		return this.optional(element) || /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i.test(value);
	}, 'Please specify a valid Postcode');

	jQuery.validator.addMethod('websiteURL', function(value, element) { // add Class websiteURL to postcode fields
		return this.optional(element) || /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+/i.test(value);
	}, 'Please specify a valid URL');

	jQuery.validator.addMethod('require_from_group', function(value, element, options) {
		var $fields = $(options[ 1 ], element.form),
			$fieldsFirst = $fields.eq(0),
			validator = $fieldsFirst.data('valid_req_grp') ? $fieldsFirst.data('valid_req_grp') : $.extend({}, this),
			isValid = $fields.filter(function() {
				return validator.elementValue(this);
			}).length >= options[0];

		$fieldsFirst.data('valid_req_grp', validator);

		if (!$(element).data('being_validated')) {
			$fields.data('being_validated', true);
			$fields.each(function() {
				validator.element(this);
			});
			$fields.data('being_validated', false);
		}
		return isValid;
	}, jQuery.validator.format('Please fill at least {0} of these fields.'));

	$('.js-form-validate').each(function(index, element){
		// jQuery Objects
		var _form = $(element),
			_equalTo;

		// Variables
		var additionalRules = {
			email: {
				email: true
			},
			business_cards: {
				number: true
			},
			A5_flyers: {
				number: true
			},
			A4_poster: {
				number: true
			},
			A3_poster: {
				number: true
			}
		};

		// Setup equalTo rules //
		// <input name="example" data-equalTo="#anotherfield"> //
		_equalTo = _form.find('[data-equalTo]'),


		_equalTo
			.each(function(index, elField){
				additionalRules[elField.name] = {
					equalTo: elField.getAttribute('data-equalTo')
				};
			});


		let validator = _form.validate({
			errorContainer: element.querySelector('.js-error-container'),
			errorLabelContainer: element.querySelector('.js-error-container'),
			wrapper: 'div',
			rules : additionalRules,
			errorPlacement: function(error, element){
				let target = element;

				let name = element.attr('name');

				if (element.parent().hasClass('niceselect-wrapper')) {
					target = element.parent();
				}
				if (element.hasClass('js-select2') && element.next('.select2-container').length) {
					target = element.next('.select2-container');
				}
				if (element.parent().hasClass('item')) {
					target = element.parent();
				}
				if (name == 'assessment[weight_weight]' || name == 'assessment[weightst]' || name == 'assessment[weightlb]' || name == 'assessment[weight_height]' || name == 'assessment[heightft]' || name == 'assessment[heightin]') {
					target = element.parent().parent();
				}

				if (element.parent().hasClass('input-replacement')) {
					target = element.parent().parent();
					target.append(error);
					return;
				}

				target.after(error);
			},
			submitHandler: function(form) {
				const $form = $(form);
				const $submitBtn = $form.find('[type=submit]');
				if ($submitBtn.length) {
					$submitBtn.text('Submitting').prop('disabled', true);
				}

				(new Recaptcha(form)).submitForm();
			},
			invalidHandler: function(event, validator) {
				var errors = validator.numberOfInvalids();
				if (errors) {
					const $submitBtn = $(this).find('[type=submit]');
					if ($submitBtn.length) {
						$submitBtn.text('Submit Enquiry').prop('disabled', false);
					}
				}
			}
		});

		_form.data('validator', validator);
	});

	$('.js-no-space').on({
		keydown: function(e) {
			if (e.which === 32) return false;
		},
		change: function() {
			this.value = this.value.replace(/\s/g, '');
		}
	});

	$('.js-introduction-validate').each(function(index, element){
		// jQuery Objects
		var _form = $(element);

		// Variables
		var additionalRules = {
			mobile: {
				require_from_group: [1, '.contact-group']
			},
			email: {
				require_from_group: [1, '.contact-group']
			}
		};

		let validator = _form.validate({
			ignore: ':hidden:not(.data-field)',
			errorContainer: element.querySelector('.js-error-container'),
			errorLabelContainer: element.querySelector('.js-error-container'),
			wrapper: 'div',
			rules : additionalRules,
			errorPlacement: function(error, element){
				let target = element;

				let name = element.attr('name');

				if (element.parent().hasClass('niceselect-wrapper')) {
					target = element.parent();
				}
				if (element.parent().hasClass('item')) {
					target = element.parent();
				}
				if (name == 'assessment[weight_weight]' || name == 'assessment[weightst]' || name == 'assessment[weightlb]' || name == 'assessment[weight_height]' || name == 'assessment[heightft]' || name == 'assessment[heightin]') {
					target = element.parent().parent();
				}

				if (element.parent().hasClass('input-replacement')) {
					target = element.parent().parent();
					target.append(error);
					return;
				}

				target.after(error);
			},
			submitHandler: function(form) {
				let $form = $(form);
				let $submitBtn = $form.find('[type=submit]');
				if ($submitBtn.length) {
					$submitBtn.text('Submitting').prop('disabled', true);
				}

				(new Recaptcha(form)).submitForm();
			}
		});

		_form.data('validator', validator);
	});


	function removeSelectRule(elem) {
		elem.find('.niceselect-wrapper select').each(function() {
			$(this).removeAttr('required');
			$(this).valid();
		});
	}

	function addSelectRule(elem) {
		elem.find('.niceselect-wrapper select').each(function() {
			$(this).prop('required', true);
			$(this).valid();
		});
	}

	function resetSelectFields(elem) {
		elem.find('.niceselect-wrapper select').each(function() {
			$(this).val('').change();
		});
	}

	$('#service-category').on('change', function() {
		if ($(this).val().length) {
			const value = $(this).val();
			const acItemEl = $('#activity-recreation-item');
			const agItemEl = $('#advice-guidance-item');
			const slItemEl = $('#skill-learn-item');

			removeSelectRule(acItemEl);
			removeSelectRule(agItemEl);
			removeSelectRule(slItemEl);
			if (!acItemEl.hasClass('hidden')) { acItemEl.addClass('hidden'); }
			if (!agItemEl.hasClass('hidden')) { agItemEl.addClass('hidden'); }
			if (!slItemEl.hasClass('hidden')) { slItemEl.addClass('hidden'); }

			switch (value) {
			case 'Advice & Guidance':
				addSelectRule(agItemEl);
				// resetSelectFields(agItemEl);
				agItemEl.removeClass('hidden');
				break;
			case 'Skills & Learning':
				addSelectRule(slItemEl);
				// resetSelectFields(slItemEl);
				slItemEl.removeClass('hidden');
				break;
			default:
				addSelectRule(acItemEl);
				// resetSelectFields(acItemEl);
				acItemEl.removeClass('hidden');
				break;
			}
		}
	}).change();

	// -----
	// Video
	// -----
	$('.cb-big-video')
		.each(function(index, el){
			var elIframe = el.querySelector('iframe');
			$(el)
				.on('click', function(){
					if (hasClass(el, 'cb-big-video__novid')) return;
					addClass(el, 'cb-big-video__play');
					elIframe.src = elIframe.getAttribute('data-src');
				});
		});


	// -------
	// Overlay
	// -------
	$('.overlay')
		.each(function(index, elOverlay){
			// Elements
			var elBoxes = elOverlay.querySelectorAll('.overlay-box'),
				elCurrentBox;

			// Functions
			var funcShowEl = function(el){
					removeClass(el, 'overlay__hide');
					setTimeout(function(){
						addClass(el, 'overlay__show');
					}, 0);
				},
				funcHideEl = function(el){
					removeClass(el, 'overlay__show');
					setTimeout(function(){
						addClass(el, 'overlay__hide');
					}, 300);
				};

			// Event Functions
			var funcHandleOverlayHide = function(event, box){
					funcHideEl(elOverlay);

					if (box) {
						funcHideEl(elCurrentBox);
						elCurrentBox = null;
					}
				},
				funcHandleOverlayShow = function(event, box){
					// if (elCurrentBox) funcHideEl(elCurrentBox);

					funcShowEl(elOverlay);

					elCurrentBox = elOverlay.querySelector(box);

					funcShowEl(elCurrentBox);
				},
				funcHandleBoxesClick = function(event){
					event.stopPropagation();
				};

			$(elOverlay)
				.on('show', funcHandleOverlayShow)
				.on('hide', funcHandleOverlayHide)
				.on('click', funcHandleOverlayHide);

			$(elBoxes)
				.on('click', funcHandleBoxesClick)
				.on('click', '.overlay_close', funcHandleOverlayHide);
		});

	$('.overlay_close')
		.on('click', function(){
			$('.overlay').trigger('hide');
		});

	$('.js-overlay-close')
		.on('click', function(){
			$('.overlay').trigger('hide');
		});


	$('.js-overlay-show')
		.on('click', function(event){
			event.preventDefault();

			var tgt = this.getAttribute('data-overlay');

			if (tgt) {
				$('.overlay')
					.trigger('show', tgt);
			}
		});

	$('.js-overlay-video')
		.on('click', function(event){
			event.preventDefault();
			var url = 'https://www.youtube.com/embed/' + this.getAttribute('data-video');
			var vid = document.getElementById('overlayvid');
			vid.src = url;
			$('.overlay')
				.trigger('show', '#overlay-video');
		});

	function updateActivities() {
		$.getJSON('/JSON/proxy/', {
			endpoint:'/public-dashboard/favourite/activity',
			method:'get',
			token: token
		}, function(res) {
			if(res.error) return;
			$('.js-favourite-toggle').removeClass('cb-blog_listing_item_fav_on');
			$.each(res, function(k, id) {
				$(`.js-favourite-toggle[data-id="${id}"]`).addClass('cb-blog_listing_item_fav_on');
			});
			console.log('active', res);
		});
	}

	// favourite articles
	var token = localStorage.getItem('access_token');
	function getCookie(name) {
		var value = '; ' + document.cookie;
		var parts = value.split('; ' + name + '=');
		if (parts.length == 2) return parts.pop().split(';').shift();
	}

	if(!token) {
		token = getCookie('mylivewell');
	}

	if(!token) {
		$('.js-favourite-toggle').click(function(event){
			event.preventDefault();
			$('.overlay').trigger('show', '#overlay-favourite');
		});
	} else {

		const elButton = document.getElementsByClassName('js-comb-register')[0];
		if (elButton) {
			elButton.innerText = 'Profile';
			elButton.href = 'https://my.livewelldorset.co.uk/profile';
			elButton.removeAttribute('data-overlay');
			elButton.onclick = function doLogout(e) {
				// localStorage.clear();
				window.location = 'https://my.livewelldorset.co.uk/profile';
				e.preventDefault();
			};
		}

		updateActivities();
		$('.js-favourite-toggle').click(function(event){
			event.preventDefault();
			$.post('/JSON/proxy/',{
				endpoint:'/public-dashboard/favourite/activity',
				method:'post',
				post: {
					activity_id: $(this).data('id')
				},
				token: token
			}, updateActivities);
		});
	}

	$('.js-activity')
		.each(function(index, elActivity){

			$(elActivity)
				.on('click', '.js-activity-toggle', function(){
					toggleClass(elActivity, 'cb-blog_listing__toggle');
				});
		});

	$('.cb-activities-search')
		.each((index, el) => {
			var q = _ad.qString(location.search);

			if (q.activity) {
				setTimeout(() => {
					let rect = el.getBoundingClientRect();
					$('html,body')
						.animate({
							scrollTop: rect.top + _ad.scrollTop()
						}, 1000);
				}, 1000);
			}
		});

	$('#overlay-team')
		.each((index, el) => {
			let elName = el.querySelector('.overlay-team_name'),
				elImg = el.querySelector('.overlay-team_img'),
				elJob = el.querySelector('.overlay-team_job'),
				elDesc = el.querySelector('.overlay-team_desc');

			$(el)
				.on('populate', (event, data) => {
					elName.textContent = data.name;
					elImg.style.backgroundImage = 'url("'+data.img+'")';
					elJob.textContent = data.job;
					elDesc.textContent = data.desc;
				});
		});

	$('.js-overlay-team')
		.each((index, el) => {
			let data = {
				img: el.dataset.image || '/site/images/placeholder/512x512.jpg',
				name: el.dataset.name,
				job: el.dataset.job,
				desc: el.dataset.desc
			};

			$(el)
				.on('click', () => {
					$('#overlay-team').trigger('populate', data);
				});
		});


	// --------------
	// Activities Map
	// --------------
	$('.cb-blog_map')
		.each((index, el) => {
			let map,
				bounds,
				openWindow;

			// let elActivities = document.querySelectorAll('.cb-blog_listing_item');
			let elActivities = document.querySelectorAll('.js-blog-map-source .sourceitem');

			_window.on('mapReady', (event) => {
				map = new google.maps.Map(el, {
					center: { lat: -34.397, lng: 150.644 },
					zoom: 8
				});

				bounds = new google.maps.LatLngBounds();

				for (let i = 0, l = elActivities.length; i < l; i++) {
					let activity = elActivities[i],
						lng = activity.getAttribute('data-lng'),
						lat = activity.getAttribute('data-lat');

					if (lng != 0 && lat != 0) {
						let latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

						bounds.extend(latlng);

						let marker = new google.maps.Marker({
							position: latlng,
							map: map,
							title: activity.dataset.name
						});

						let link = '';
						if (activity.dataset.link) link = ' href="'+activity.dataset.link+'"';

						let email = activity.dataset.email ? `<a href="mailto:${activity.dataset.email}">${activity.dataset.email}</a><br>` : '',
							type = activity.dataset.type ? `<strong class="colour-highlight">${activity.dataset.type}</strong><br>` : '',
							telephone = activity.dataset.telephone ? `${activity.dataset.telephone}<br>` : '';

						let infoWindow = new google.maps.InfoWindow({
							content: `<h2><a${link}>${activity.dataset.name}</a></h2>
								<p>
									${type}
									${email}
									${telephone}
									${activity.dataset.address}
								</p>`
						});

						marker.addListener('click', () => {
							if (openWindow) openWindow.close();
							infoWindow.open(map, marker);
							openWindow = infoWindow;
							map.setCenter(marker.position);
						});
					}
				}

				map.fitBounds(bounds);
			});
		});


	// ----
	// Blog
	// ----
	$('.cb-blog')
		.each((index, el) => {
			let elListing = el.querySelector('.cb-blog_listing'),
				elPagination = el.querySelector('.cb-blog_bar'),
				elMap = el.querySelector('.cb-blog_map');
			$(el)
				.on('click', '.js-blog-showgrid', () => {
					addClass(elMap, 'cb-blog_hidden');
					removeClass(elListing, 'cb-blog_hidden');
					removeClass(elPagination, 'hidden');
				})
				.on('click', '.js-blog-showmap', () => {
					addClass(elListing, 'cb-blog_hidden');
					removeClass(elMap, 'cb-blog_hidden');
					addClass(elPagination, 'hidden');
				});
		});


	// ---------
	// Scroll In
	// ---------
	(function(){
		var cache = {};
		cache.scrollTop = _ad.scrollTop();
		cache.windowHeight = _window.height();

		var _cb = $('.content-block');

		_cb
			.on('test', function(){
				var rect = this.getBoundingClientRect();

				if (hasClass(this, 'inview')) return;

				if (rect.top < cache.windowHeight) {
					removeClass(this, 'outofview');
					addClass(this, 'inview');
				} else {
					addClass(this, 'outofview');
				}
			});

		_window
			.on('scroll', function(){
				cache.scrollTop = _ad.scrollTop();
				_cb.trigger('test');
			});
	})();



	// -----
	// Com-B
	// -----
	// $('.js-comb-register')
	// 	.on('click', function(event){
	// 		event.preventDefault();
	// 		var tgt = this.getAttribute('data-overlay');
	// 		if (tgt) {
	// 			$('.overlay')
	// 				.trigger('show', tgt);
	// 		}
	// 	});

	$('.js-comb')
		.each(function(index, elComb){
			// Elements
			var elPathwaySelector = elComb.querySelector('.js-comb-pathway'),
				elPathwayIntro = elComb.querySelector('.js-pathway-intro'),
				elPathwayTitle = elComb.querySelector('.js-pathway-title'),
				elSections = elComb.querySelectorAll('.comb_section'),
				elInputsScale = elComb.querySelectorAll('.js-comb-scale input'),
				elInputsChallenges = elComb.querySelectorAll('.js-comb-challenges input'),
				elInputsHacks = elComb.querySelectorAll('.js-comb-hacks input'),
				elCombChallenges = elComb.querySelector('.js-comb-challenges'),
				elCombHacks = elComb.querySelector('.js-comb-hacks'),
				elCombBcts = elComb.querySelector('.js-comb-bcts'),
				elScale1 = elComb.querySelector('.js-scale-1'),
				elScale2 = elComb.querySelector('.js-scale-2'),
				elScale3 = elComb.querySelector('.js-scale-3'),
				elScale4 = elComb.querySelector('.js-scale-4'),
				elBctDefault = elComb.querySelector('.js-bctdefault');

			elBctDefault = elBctDefault.cloneNode(true);


			// Variables
			let pathway = '',
				barrier = '',
				hack = '';

			var content = {};
			content.activity = {
				intro: 'Did you know that physical activity can improve your energy levels, fitness, strength and mobility and boost your mood. It can also reduce your risk of many chronic conditions such as heart disease, diabetes, depression, high blood pressure, high cholesterol levels, joint and bone problems.',
				title: 'How <span class="colour-alt weight-black">active</span> are you?',
				scale: [
					'I\'m thinking about being more active, but need some extra support to get started.',
					'I\'m a bit active, but not more than about 30 minutes a week.',
					'I\'m quite active, about 30 minutes 5 times a week. But, I haven\'t been doing this for at least 6 months.',
					'I\'m very active, at least 30 minutes 5 times a week and have been for at least 6 months.'
				],
				barriers: {}
			};
			content.weight = {
				intro: 'Did you know that losing weight can boost your energy levels, improve the quality of your sleep, decrease the likelihood that you will get ill and improve your mood? Once you start your weight loss journey, you’ll discover just how good it feels to be healthier!',
				title: 'How is your <span class="colour-alt weight-black">diet</span>?',
				scale: [
					'I\'m thinking about losing some weight, but need some help to get started.',
					'I\'ve started trying to reduce my weight but need help to keep motivated.',
					'I\'m quite good at looking after my weight. But I haven\'t been doing this for at least 6 months.',
					'I am happy with my current weight and have been for at least 6 months.'
				],
				barriers: {}
			};
			content.smoking = {
				intro: 'Stopping smoking will improve the health of pretty much every part of your body. You’ll be less likely to suffer from a stroke, lung disease, cancer, poor vision and a seemingly never-ending list of health problems. Start your journey to becoming smoke free today.',
				title: 'How much do you <span class="colour-alt weight-black">smoke</span>?',
				scale: [
					'I\'m thinking about quitting smoking, but need some extra support to get started.',
					'I\'ve reduced how much I am smoking but need extra support to go further.',
					'I\'ve quit smoking but it has been less than six months since I quit.',
					'It has been over 6 months since I quit.'
				],
				barriers: {}
			};
			content.alcohol = {
				intro: 'Did you know that reducing your alcohol intake will improve your long term physical health, mental health and even leave you feeling more energetic? Not only that, but you’ll notice improvements in your appearance too! Start your journey towards drinking less today.',
				title: 'How much do you <span class="colour-alt weight-black">drink</span>?',
				scale: [
					'I\'m thinking about reducing my intake, but need some extra support to get started.',
					'I\'ve reduced how much I am drinking but need extra support to go further.',
					'I\'ve quit drinking but it has been less than six months since I quit.',
					'It has been over 6 months since I quit.'
				],
				barriers: {}
			};

			// Functions
			var funcGoTo = function(index) {
					var el = elComb.querySelector('#comb-step-'+index);
					addClass(el, 'comb_section__show');
					_ad.createCookie('comb-step', index, 1);
					var rect = el.getBoundingClientRect();

					$('html,body')
						.animate({
							scrollTop: rect.top + _ad.scrollTop()
						});
				},
				funcReset = function(pathchanged){
					if (pathchanged) {
						for (var i = 0, l = elSections.length; i < l; i++) {
							if (i > 1) removeClass(elSections[i], 'comb_section__show');
						}

						funcResetRadio(elInputsScale);
						funcResetRadio(elInputsChallenges);
						funcResetRadio(elInputsHacks);
					}
				},
				funcResetRadio = function(els){
					for (var i = 0, l = els.length; i < l; i++) {
						els[i].checked = false;
					}
				},
				funcSetupData = function(data){
					for (let i = 0, l = data.length; i < l; i++) {
						let d = data[i];

						if (!d.web_friendly_barrier) continue;

						content[d.pathway].barriers[d.barrier] = {
							value: d.barrier,
							label: d.web_friendly_barrier,
							bcts: d.bcts,
							id: d.id
						};

						funcPathwaySelect();
					}
				},
				funcPathwaySelect = function(pathchanged) {
					if(elPathwaySelector.value != '') {
						let c = content[elPathwaySelector.value];
						pathway = elPathwaySelector.value;

						elComb.setAttribute('data-pathway', elPathwaySelector.value);
						elPathwayIntro.innerHTML = c.intro;
						elPathwayTitle.innerHTML = c.title;
						elScale1.innerHTML = c.scale[0];
						elScale2.innerHTML = c.scale[1];
						elScale3.innerHTML = c.scale[2];
						elScale4.innerHTML = c.scale[3];

						let challengeHTML = '';
						for (let p in c.barriers) {
							let row = c.barriers[p];
							challengeHTML += tmplBarrier(row);
						}
						elCombChallenges.innerHTML = challengeHTML;
					}

					if(!_ad.readCookie('comb-pathway') && pathway != '') {
						_ad.createCookie('comb-pathway', pathway, 1);
					}

					if (pathchanged && pathway != '') {
						_ad.createCookie('comb-pathway', pathway, 1);
						funcReset(pathchanged);
					}
				};

			// Templates

			var tmplBarrier = function(data){
					return `<li>
						<label>
							<input type="radio" name="challenge" value="${data.value}" data-string="${data.id}">

							<div class="comb_challenges_item_inner">
								<h3>${data.label}</h3>
							</div>
						</label>
					</li>`;
				},
				tmplBCT = function(data){
					data.pivot.web_friendly_text = $('<div />').text(data.pivot.web_friendly_text).html();
					data.name = $('<div />').text(data.name).html();
					return `<li>
						<label>
							<input name="hacks" value="${data.id}" type="radio" data-string="${data.id}">

							<div class="comb_challenges_item_inner">
								<div>
									<p><img src="/site/images/icon/habithacker/${data.name.toLowerCase().replace(/\s/g, '-').replace('/', '')}.svg" alt="" height="101"></p>
									<h3>${data.web_friendly_name}</h3>
									<p>${data.pivot.web_friendly_text}</p>
								</div>
							</div>
						</label>
					</li>`;
				},
				tmplArticle = function(data){
					let strReturn = `<p><img src="/site/images/icon/white/icon-document.png" alt=""></p>
						<h3>${data.title}</h3>
						<p>${data.intro}</p>`;

					if(data.title == 'Introducing the Activity Finder') {
						return strReturn + `<p><a href="${data.url}" class="button">Activity Finder</a></p>`;
					}else {
						return strReturn + `<p><a href="${data.url}" class="button">Read more</a></p>`;
					}
				};

			// Setup
			let dataSet = false;
			// if (window.localStorage) { // Start work on a cache //
			// 	dataSet = localStorage.getItem('comB');
			// 	if (dataSet) {
			// 		dataSet = JSON.parse(dataSet);
			// 		funcSetupData(dataSet);
			// 	}
			// 	else {
			// 		dataSet = false;
			// 	}

			// }
			// https://lwd.publicapi.adidodev.com/bcts
			// 	/json/bcts.json
			if (!dataSet) {
				// $.ajax('https://cors.io/?https://www.livewelldorset.co.uk/json/bcts.json', {
				$.ajax('/json/bcts.json', {
					success: (data, status, xhr) => {
						// dataSet = data;
						// if (window.localStorage) localStorage.setItem('comB', JSON.stringify(data));
						// funcSetupData(JSON.parse(data));
						funcSetupData(data);
					}
				});
			}

			$(elComb)
				.on('change', '.js-comb-pathway', function(){
					funcPathwaySelect(true);
					funcGoTo(2);
				})
				.on('change', '.js-comb-scale input', function(){
					_ad.createCookie('comb-scale', $('.js-comb-scale input[name=scale]:checked').val(), 1);
					funcGoTo(3);
				})
				.on('change', '.js-comb-challenges input', function(){

					barrier = this.value;
					_ad.createCookie('comb-barrier', barrier, 1);
					funcGoTo(4);

					let bcts = content[pathway].barriers[barrier].bcts;
					let hacksHTML = '';
					for (let i = 0, l = bcts.length; i < l; i++) {
						if (!bcts[i].web_friendly_name) continue;
						if (!bcts[i].pivot.web_friendly_text) continue;
						hacksHTML += tmplBCT(bcts[i]);
					}
					elCombHacks.innerHTML = hacksHTML;
				})
				.on('change', '.js-comb-hacks input', function(){
					hack = this.value;
					_ad.createCookie('comb-hack', hack, 1);

					let uid = '*'+content[pathway].barriers[barrier].id+'-'+hack+'*';

					$.ajax('/json/articles.json', {
						data: {
							uid: uid
						},
						success: (data) => {
							elCombBcts.innerHTML = '';
							elCombBcts.appendChild(elBctDefault);

							for (let i = 0, l = data.length; i < l; i++) {
								let el = document.createElement('div');
								addClass(el, 'cb-panels_panel');
								el.innerHTML = tmplArticle(data[i]);
								elCombBcts.appendChild(el);
							}
						}
					});

					funcGoTo(5);
				})
				.on('click', '.js-comb-goto', function(event){
					event.preventDefault();
					funcGoTo(this.getAttribute('data-goto'));
				})
				.on('click', '.js-comb-register', function(event){

					let link = $('.js-comb-register').attr('href');
					link += '?pathway='+$('.js-comb-pathway').val();
					link += '&barrier='+$('input[name="challenge"]:checked')[0].dataset.string;
					link += '&bct='+$('input[name="hacks"]:checked')[0].dataset.string;

					$('.js-comb-register').attr('href', link);
					// event.preventDefault();
					// var tgt = this.getAttribute('data-overlay');
					// if (tgt) {
					// 	$('.overlay')
					// 		.trigger('show', tgt);
					// }
				});

			funcPathwaySelect();

			if (_ad.readCookie('comb-pathway')) {
				const cookiePath = _ad.readCookie('comb-pathway');
				console.log(document.referrer);
				console.log(cookiePath);

				if(document.referrer.indexOf(cookiePath) > -1 || document.referrer.indexOf('habit') > -1 || document.referrer === '') {
					$('.js-comb-pathway').val(cookiePath).change();
				}else if(document.referrer.indexOf('active') > -1){
					$('.js-comb-pathway').val('activity').change();
				}else if(document.referrer.indexOf('weight') > -1){
					$('.js-comb-pathway').val('weight').change();
				}else if(document.referrer.indexOf('smoking') > -1){
					$('.js-comb-pathway').val('smoking').change();
				}else if(document.referrer.indexOf('drink') > -1){
					$('.js-comb-pathway').val('alcohol').change();
				}

				if(_ad.readCookie('comb-scale')) {
					const cookieScale = _ad.readCookie('comb-scale');
					$('.js-comb-scale input[name=scale][value=' + cookieScale + ']').prop('checked', true).trigger('change');

					if (_ad.readCookie('comb-barrier') && _ad.readCookie('comb-barrier').length) {
						const cookieBarrier =  _ad.readCookie('comb-barrier');

						$.ajax('/json/bcts.json', {
							success: (data, status, xhr) => {
								funcSetupData(data);

								barrier = cookieBarrier;
								let bcts = content[cookiePath].barriers[cookieBarrier].bcts;
								let hacksHTML = '';
								for (let i = 0, l = bcts.length; i < l; i++) {
									if (!bcts[i].web_friendly_name) continue;
									if (!bcts[i].pivot.web_friendly_text) continue;
									hacksHTML += tmplBCT(bcts[i]);
								}
								elCombHacks.innerHTML = hacksHTML;
								$('.js-comb-challenges input[name=challenge][value="' + cookieBarrier + '"]').prop('checked', true).trigger('change');

								if (_ad.readCookie('comb-hack') && _ad.readCookie('comb-hack').length) {
									const cookieHack =  _ad.readCookie('comb-hack');
									$('.js-comb-hacks input[name=hacks][value="' + cookieHack + '"]').prop('checked', true).trigger('change');
								}
							}
						});
					}
				}
			}
		});

	function selectorSearch (elInput, url, level, onChangeHandler) {
		const self = this;
		self.elSeachPopup = $(elInput).closest('.searchbox-popup');
		self.elPopupCloseBtn = this.elSeachPopup.find('.js-popup-close');

		self.elHiddenData = $(elInput).find('.data-field');

		self.elSearchBox = $(elInput).find('.select-search-box-search');
		self.elSearchSelectBox = $(elInput).find('.select-search-box-select');
		self.elOptsContainer = $(elInput).find('.select-search-box-options');

		self.search = '';
		self.searchValue = 0;
		self.referralValue = elInput.value || '';
		self.referral1Opts = [];
		self.defaultreferral1Opts = [];
		self.selectedOpt = null;
		self.selectedId = null;

		self.defaultValue = $(self.elHiddenData).val();

		self.generateOptsList = (opts) => {
			let output = '<li data-value="-1">Select One...</li>';

			for (let i = 0, l = opts.length; i < l; i++) {
				output += `<li role="selectItem" data-value="${opts[i].id}" class="referral-opt-item ${self.searchValue === opts[i].id ? 'selected' : ''}">${opts[i].value}</li>`;
				self.elOptsContainer.html(output);
			}
		};
		self.hideOptsList = (el) => {
			el.removeClass('display');
		};
		self.showOptsList = (el) => {
			el.addClass('display');
		};
		self.findByValue = (opts, value, key = 'id') => {
			let results = opts;

			if (!opts || opts.length < 1) {
				results = self.defaultreferral1Opts;
			}
			if (!results) {
				return null;
			}

			return results.filter(object => {
				if (key === 'id') return parseInt(object.id, 10) === parseInt(value, 10);

				return object[key] === value;
			})[0];
		};
		self.getNewOptionsList = (opts, value) => {
			if (opts && opts.length > 0 && value && value.length > 0) {
				return opts.filter(item => item.value.toLowerCase().includes(value));
			}

			return opts;
		};
		self.publishOption = (value) => {
			let publishValue = value;
			if (typeof value === 'undefined') {
				publishValue = self.searchValue;
			}
			return self.findByValue(null, publishValue);
		};
		self.handleOutsideClick = function(e) {
			if (elInput && elInput.contains(e.target)) {
				return;
			}

			if (self.searchValue) {
				const option = self.findByValue(null, self.searchValue);
				if (option) {
					self.search = option.value;
					self.elSearchBox.val(self.search).change();
				}
			}

			self.hideOptsList(self.elSearchSelectBox);
		};
		self.scrollToSelected = (force = false) => {
			const selectedItem = elInput.querySelector('.selected');

			if(!force && (!self.elSearchSelectBox.length || !self.elSearchBox.is(':focus') || self.elOptsContainer.querySelectorAll('.referral-opt-item').length < 1) || !self.referral1Opts) {
				return;
			}

			if (selectedItem) {
				const searchOffset = self.elSearchBox ? self.elSearchBox.height() : 0;
				self.elSearchSelectBox.scrollTop(selectedItem.offsetTop - searchOffset - 200 / 2 + selectedItem.clientHeight / 2);
			}
		};
		self.addElDisable = () => {
			$(elInput).addClass('niceselect-disabled');
			self.elSearchBox.prop('disabled', true);
		};
		self.handleOptionSelect = (opt) => {
			self.searchValue = opt.id;
			self.search = opt.value;
			self.selectedId = opt.id;

			self.hideOptsList(self.elSearchSelectBox);

			const publishOpt = self.publishOption(opt.id);
			self.selectedOpt = publishOpt;
			self.elSearchBox.val(self.selectedOpt.value).change();

			if (level === 'level2' || level === 'level3') {
				self.elHiddenData.val(self.selectedOpt.value).change();
			} else {
				self.elHiddenData.val(self.selectedOpt.id).change();
			}
			self.elHiddenData.valid();

			self.elSearchBox.blur();
			if (window.matchMedia('(max-width: 540px)').matches) {
				self.elSeachPopup.removeClass('openSelector');
			}
		}
		self.selectDefaultOption = () => {
			if (! self.defaultValue) return;

			// find default value in drop-down options
			const key = level === 'level2' || level === 'level3' ? 'value' : 'id';
			const opt = self.findByValue(self.defaultreferral1Opts, self.defaultValue, key);

			if (! opt) {
				// opt not found - clear default value
				self.elHiddenData.val('').change();

				return;
			};

			self.handleOptionSelect(opt);

			// trigger change for first-level dropdown
			if (level !== 'level2' && level !== 'level3') onChangeHandler();

			// remove default value so that it's only set on first render
			self.defaultValue = null;
		};
		self.updateData = (newURL) => {
			$.ajax(newURL, {
				success: (data, status, xhr) => {
					let opts = [];
					console.log('data', data);

					if (level === 'level2') {
						// opts = JSON.parse(JSON.stringify(data.level2));
						opts = data;
						opts.sort(function (a, b) {
							let fa = a.value.toLowerCase(),
								fb = b.value.toLowerCase();

							if (fa < fb) {
								return -1;
							}
							if (fa > fb) {
								return 1;
							}
							return 0;
						});
					} else if (level === 'level3') {
						opts = data;
						opts.sort(function (a, b) {
							let fa = a.value.toLowerCase(),
								fb = b.value.toLowerCase();

							if (fa < fb) {
								return -1;
							}
							if (fa > fb) {
								return 1;
							}
							return 0;
						});
					} else {
						opts = data.data;
					}


					self.referral1Opts = opts;
					self.defaultreferral1Opts = opts;

					self.search = self.findByValue(self.referral1Opts, self.referralValue);
					self.searchValue = self.referralValue;

					self.generateOptsList(opts);

					self.selectDefaultOption();

					// set selected if there's only one option
					if(opts.length === 1 && (level === 'level2' || level === 'level3')) {
						self.selectedId = opts[0].id;
						self.elSearchBox.val(opts[0].value).change();
						self.elHiddenData.val(opts[0].value).change();
						self.elHiddenData.valid();
						self.addElDisable();
					}
				}
			});
		};
		self.removeElDisable = () => {
			self.search = '';
			self.searchValue = 0;
			self.selectedOpt = null;
			$(elInput).removeClass('niceselect-disabled');
			self.elSearchBox.prop('disabled', false);
			self.elSearchBox.val('').change();
			self.elHiddenData.val('').change();
			self.elHiddenData.valid();
		};

		if (url) {
			this.updateData(url);
		}

		$(elInput)
			.on('input change', '.select-search-box-search', function() {
				let val = $(this).val();
				if (!val) { val = ''; }

				let options = self.defaultreferral1Opts;
				options = self.getNewOptionsList(options, val.toLowerCase());
				self.search = val;
				self.referral1Opts = options;

				self.generateOptsList(self.referral1Opts);
			})
			.on('change', '.data-field', function() {
				if (onChangeHandler && typeof onChangeHandler === 'function') {
					onChangeHandler();
				}
			})
			.on('focus', '.select-search-box-search', function(e) {
				e.stopPropagation();
				// $(document).off('click.closeOutside');
				document.removeEventListener('click', self.handleOutsideClick, false);

				self.search = '';
				$(this).val('').change();

				self.showOptsList(self.elSearchSelectBox);

				if (window.matchMedia('(max-width: 540px)').matches) {
					self.elSeachPopup.addClass('openSelector');
				}

				const { clientHeight } = document.documentElement;
				const viewportHeight = Math.max(clientHeight, window.innerHeight || 0);
				const selectHeight = viewportHeight - self.elSearchSelectBox[0].getBoundingClientRect().top - 20;
				self.elSearchSelectBox.css({ 'max-height': `${selectHeight}px` });

				self.scrollToSelected(true);
			})
			.on('blur', '.select-search-box-search', function() {
				// $(document).on('click.closeOutside', self.handleOutsideClick);
				document.addEventListener('click', self.handleOutsideClick, false);
			})
			.on('click', '.referral-opt-item', function() {
				const value = $(this).attr('data-value');
				const opt = self.findByValue(self.defaultreferral1Opts, value);
				if (! opt) return;

				self.handleOptionSelect(opt);
			});

		self.elPopupCloseBtn.on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			self.hideOptsList(self.elSearchSelectBox);
			if (self.selectedOpt) {
				self.elSearchBox.val(self.selectedOpt.value).change();
			}
			self.elSearchBox.blur();
			self.elSeachPopup.removeClass('openSelector');
		});
	}

	$('.js-introduction')
		.each((index, el) => {
			let elReferral1 = el.querySelector('#register-hearabout'),
				elReferral2 = el.querySelector('#register-hearwhere'),
				elReferral3 = el.querySelector('#register-hearregard');

			const referral2SearchSelector = new selectorSearch(elReferral2, '', 'level2', function() {
				const elReferral2HiddenField = $(elReferral2).find('.data-field');
				if(elReferral2HiddenField.val()) {
					const level3 = `${path}referrals/3-${referral2SearchSelector.selectedId}`;
					console.log('level3', level3);
					referral3SearchSelector.removeElDisable();
					referral3SearchSelector.updateData(level3);
				}
			});
			const referral3SearchSelector = new selectorSearch(elReferral3, '', 'level3');
			// const path = '/json/dropdowns.json?referral=1';
			const path = 'https://publicapi.livewelldorset.co.uk/';
			// const path = 'http://publicapi.livewelldorset.co.uk.test/';
			// const path = 'https://lwdazure.adidodev.com/';
			const referral1SearchSelector = new selectorSearch(elReferral1, `${path}referrals?public=1`, '', function() {
				const elReferral1HiddenField = $(elReferral1).find('.data-field');

				const level2 = `${path}referrals/${elReferral1HiddenField.val()}`;
				console.log('level2', level2);
				referral2SearchSelector.removeElDisable();
				referral2SearchSelector.updateData(level2);

				// referral3SearchSelector.removeElDisable();
				// referral3SearchSelector.updateData('/json/dropdowns.json?referrals='+elReferral1HiddenField.val());
			});
		});

	// -------
	// Cookies
	// -------r
	if (false && _ad.readCookie('policy') !== 'accepted') {
	} else {
		_ad.createCookie('policy', 'accepted', 365);
	}

	// $('.js-register')
	// 	.on('click', function(){
	// 		alert('ae');
	// 		_ad.createCookie('gdprpolicy', 'accepted', 1);
	// 	});

	$('.js-datepicker-dob').datepicker({
		defaultDate: '-18y',
		minDate: '-70y',
		yearRange: 'c-70:c',
		changeMonth: true,
		changeYear: true
	});


	// -------------
	// Media Queries
	// -------------
	(function(){
		var updateTel = function(mq){
			if (mq.matches) {
				$('[data-tel]')
					.each(function(index, el){
						var _el = $(el);
						_el.attr('href', 'tel:'+_el.data('tel'));
					});
			} else {
				$('[data-tel]').removeAttr('href');
			}
		};
		if (window.matchMedia) {
			var mq = window.matchMedia( '(max-width: 767px)' );
			if (mq.addListener) {
				mq.addListener(updateTel);
			}
			updateTel(mq);
		}
	})();

	// share links
	if ($('.share-links').length > 0) {
		attn.shareLinks({
			wrapper: '.share-links',
			services: 'pinterest,facebook,twitter,googleplus',
			linkClassPrefix: 'icon-',
			textClass: 'off-screen'
		});
	}


	// ---------
	// Polyfills
	// ---------

	// --------------------
	// Placeholder Function
	// --------------------
	function placeholderFunc(index, element) {
		var ph = element.getAttribute('placeholder'),
			_input = $(this);

		_input.on({
			focus: function(){
				if (element.value == ph) {
					element.value = '';
					removeClass(element, 'placeholder-replacement');
				}
			},
			blur: function(){
				if (element.value == '') {
					element.value = ph;
					addClass(element, 'placeholder-replacement');
				}
			}
		}).blur();

	}


	// -----------
	// Placeholder
	// -----------
	if(!Modernizr.input.placeholder)
	{
		$('html').addClass('no-placeholder');

		$('form:not(.js-no-placeholder)').each(function(index, elForm){
			$(elForm).find('[placeholder]').each(placeholderFunc);
		});

		$('form')
			.on('submit', function(){
				var elInputs = this.querySelectorAll('[placeholder]');

				for (var i = 0, l = elInputs.length; i < l; i++) {
					if (elInputs[i].value === elInputs[i].getAttribute('placeholder')) {
						elInputs[i].value = '';
					}
				}
			});
	}

	$('.js-back-to-lwf').on('click', function(evt) {
		evt.preventDefault();
		if (document.referrer.indexOf(window.location.host) !== -1){
			history.back();
		} else {
			window.location = '/livewell-finder/';
		}
	});

	// Select all <a> elements that contain only an <img>
	document.querySelectorAll('.content-area a').forEach(function(link) {
		const children = link.children;
		if (children.length === 1 && children[0].tagName.toLowerCase() === 'img') {
			const titleText = link.getAttribute('title');
			if (titleText) {
				const span = document.createElement('span');
				span.className = 'sr-only';
				span.textContent = titleText;
				link.appendChild(span);
			}
		}
	});
})();